import { useCallback, useEffect } from 'react';
import { CACHE_TTL, isCacheValid } from '@/utils/cache';
import { useRegieStore } from '@/zustand';
import useIndicateursStore from '@/zustand/accueil/useIndicateursStore';

/**
 * Hook pour récupérer les indicateurs clés avec cache automatique
 * Vérifie le cache à chaque utilisation et fetch si nécessaire
 */
const useIndicateursData = () => {
  const regieId = useRegieStore((state) => state.regie?.identifiant);

  const indicateurs = useIndicateursStore((state) => state.data);
  const loading = useIndicateursStore((state) => state.loading);
  const error = useIndicateursStore((state) => state.error);
  const cache = useIndicateursStore((state) => state.cache);
  const fetch = useIndicateursStore((state) => state.fetch);

  // Vérification du cache à chaque utilisation du hook
  useEffect(() => {
    if (regieId && !isCacheValid(cache.timestamp, CACHE_TTL.INDICATEURS, cache.regieId, regieId)) {
      fetch(regieId);
    }
  }, [regieId, cache.timestamp, cache.regieId, fetch]);

  // Fonction pour forcer un refresh manuel
  const refresh = useCallback(() => {
    if (regieId) {
      fetch(regieId, true);
    }
  }, [regieId, fetch]);

  return {
    indicateurs,
    loading,
    error,
    refresh,
  };
};

export default useIndicateursData;
